import { createContext, useContext, useState, type ReactNode } from 'react';

interface DemoModeContextValue {
  isDemoActive: boolean;
  setIsDemoActive: (value: boolean) => void;
}

const DemoModeContext = createContext<DemoModeContextValue>({
  isDemoActive: false,
  setIsDemoActive: () => {},
});

export function DemoModeProvider({ children }: { children: ReactNode }) {
  const [isDemoActive, setIsDemoActive] = useState(false);
  return (
    <DemoModeContext.Provider value={{ isDemoActive, setIsDemoActive }}>
      {children}
    </DemoModeContext.Provider>
  );
}

export function useDemoMode() {
  return useContext(DemoModeContext);
}
